/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerFindOneQueryResponse, TemplateActivationsControllerFindOnePathParams, TemplateActivationsControllerFindOneQueryParams, TemplateActivationsControllerFindOne400, TemplateActivationsControllerFindOne401, TemplateActivationsControllerFindOne403, TemplateActivationsControllerFindOne404 } from "../../models/checklistsController/TemplateActivationsControllerFindOne";

function getTemplateActivationsControllerFindOneUrl(id: TemplateActivationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-template-activations/${id}` as const }  
  return res
}

/**
 * @summary Get a specific template activation by ID
 * {@link /api/v1/checklist-template-activations/:id}
 */
export async function templateActivationsControllerFindOne(id: TemplateActivationsControllerFindOnePathParams["id"], params?: TemplateActivationsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateActivationsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateActivationsControllerFindOne400 | TemplateActivationsControllerFindOne401 | TemplateActivationsControllerFindOne403 | TemplateActivationsControllerFindOne404>, unknown>({ method : "GET", url : getTemplateActivationsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}